export default __webpack_public_path__ + "static/media/img6.6dc16b17.jpg";